<template>
    <input v-bind:type="type" v-bind:name="name" class="form-control m-input" :class="inputClass" v-bind:id="id" v-bind:placeholder="placeholder" v-bind:value="value">
</template>

<script>
export default {
  name: 'InputTextComponent',
  props: ['id', 'value', 'name', 'placeholder', 'type', 'inputClass']
}
</script>



// WEBPACK FOOTER //
// src/components/core/form/inputs/InputTextComponent.vue